class RegearProductTabs extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.tabs.length || !this.panels.length) return;

    this.listeners = new AbortController();
    const listenerOptions = { signal: this.listeners.signal };
    this.dataset.enhanced = '';
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index), listenerOptions);
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index), listenerOptions);
    });
    document.querySelectorAll('[data-regear-condition-link]').forEach((link) => {
      link.addEventListener('click', (event) => this.openCondition(event), listenerOptions);
    });
    this.select(0, false);
    this.selectFromHash();
    window.addEventListener('hashchange', () => this.selectFromHash(), listenerOptions);
  }

  disconnectedCallback() {
    this.listeners?.abort();
    this.initialised = false;
  }

  selectFromHash() {
    if (window.location.hash !== '#regear-buying-details') return;
    const index = this.tabs.findIndex((tab) => tab.textContent.trim().toLowerCase() === 'condition');
    if (index >= 0) this.select(index, false);
  }

  openCondition(event) {
    const conditionIndex = this.tabs.findIndex((tab) => tab.textContent.trim().toLowerCase() === 'condition');
    if (conditionIndex === -1) return;

    event.preventDefault();
    this.select(conditionIndex, false);
    this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    this.tabs[conditionIndex].focus({ preventScroll: true });
    history.replaceState(null, '', '#regear-buying-details');
  }

  select(index, moveFocus = true) {
    this.dataset.activeTab = this.tabs[index].textContent.trim().toLowerCase();
    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', selected.toString());
      tab.tabIndex = selected ? 0 : -1;
      this.panels[tabIndex].hidden = !selected;
    });
    if (moveFocus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.select(next);
  }
}

if (!customElements.get('regear-product-tabs')) customElements.define('regear-product-tabs', RegearProductTabs);
